import { uiText } from "@/lib/i18n/uiText";
import { useEffect, useState } from "react";
import { WifiOff, Wifi } from "lucide-react";

/** Slim connection banner: offline notice, then a brief "Back online" confirmation. */
export function OfflineBanner() {
  const [state, setState] = useState<"online" | "offline" | "back">("online");
  useEffect(() => {
    if (!navigator.onLine) setState("offline");
    let t: number | undefined;
    const off = () => setState("offline");
    const on = () => {
      setState("back");
      t = window.setTimeout(() => setState("online"), 3000);
    };
    window.addEventListener("offline", off);
    window.addEventListener("online", on);
    return () => {
      window.removeEventListener("offline", off);
      window.removeEventListener("online", on);
      if (t) clearTimeout(t);
    };
  }, []);
  if (state === "online") return null;
  const offline = state === "offline";
  return (
    <div
      role="status"
      aria-live="polite"
      className={`fixed top-0 inset-x-0 z-50 flex items-center justify-center gap-2 py-1.5 text-xs font-medium ${offline ? "bg-destructive text-destructive-foreground" : "bg-primary text-primary-foreground"}`}
    >
      {offline ? <WifiOff className="h-3.5 w-3.5" aria-hidden /> : <Wifi className="h-3.5 w-3.5" aria-hidden />}
      {offline ? uiText("You're offline — showing saved pages.") : uiText("Back online")}
    </div>
  );
}
